export const stepTracker = {
	0: {
		step: 0,
		url: '/',
		access: true,
		displayStep: null,
		nextStep: 1,
		altNextStep: null,
		prevStep: null,
		altPrevStep: null,
		altForward: false,
		altBack: false	
	},
	1: {
		step: 1,
		url: '/visitor-questionnaire',
		access: false,
		displayStep: 1,
		nextStep: 2,
		altNextStep: 3,
		prevStep: 0,
		altPrevStep: null,
		altForward: false,
		altBack: false	
	},
	2: {
		step: 2,
		url: '/work-history',
		access: false,
		displayStep: 2,
		nextStep: 3,
		altNextStep: null,
		prevStep: 1,
		altPrevStep: null,
		altForward: false,
		altBack: false	
	},
	3: {
		step: 3,
		url: '/who-to-visit',
		access: false,
		displayStep: 3,
		nextStep: 4,
		altNextStep: null,
		prevStep: 2,
		altPrevStep: 1,
		altForward: false,
		altBack: false	
	},
	4: {
		step: 4,
		url: '/visitor-offender-relationship',
		access: false,
		displayStep: null,
		nextStep: 5,
		altNextStep: null,
		prevStep: 3,
		altPrevStep: null,
		altForward: false,
		altBack: false	
	},
	5: {
		step: 5,
		url: '/selected-offenders',
		access: false,
		displayStep: 4,
		nextStep: 6,
		altNextStep: null,
		prevStep: 3,
		altPrevStep: null,
		altForward: false,
		altBack: false	
	},
	6: {
		step: 6,
		url: '/applicant-information',
		access: false,
		displayStep: 5,
		nextStep: 7,
		altNextStep: null,
		prevStep: 5,
		altPrevStep: null,
		altForward: false,
		altBack: false	
	},
	7: {
		step: 7,
		url: '/applicant-physical',
		access: false,
		displayStep: 6,
		nextStep: 8,
		altNextStep: null,
		prevStep: 6,
		altPrevStep: null,
		altForward: false,
		altBack: false	
	},
	8: {
		step: 8,
		url: '/applicant-contact',
		access: false,
		displayStep: 7,
		nextStep: 9,
		altNextStep: null,
		prevStep: 7,
		altPrevStep: null,
		altForward: false,
		altBack: false	
	},
	9: {
		step: 9,
		url: '/add-minor',
		access: false,
		displayStep: null,
		nextStep: 10,
		altNextStep: 14,
		prevStep: 8,
		altPrevStep: null,
		altForward: false,
		altBack: false
	},
	10: {
		step: 10,
		url: '/minor-questionnaire',
		access: false,
		displayStep: 8,
		nextStep: 11,
		altNextStep: null,
		prevStep: 9,
		altPrevStep: null,
		altForward: false,
		altBack: false
	},
	11: {
		step: 11,
		url: '/minor-information',
		access: false,
		displayStep: 9,
		nextStep: 12,
		altNextStep: null,
		prevStep: 10,
		altPrevStep: null,
		altForward: false,
		altBack: false
	},
	12: {
		step: 12,
		url: '/minor-visit-selection',
		access: false,
		displayStep: null,
		nextStep: 13,
		altNextStep: null,
		prevStep: 11,
		altPrevStep: null,
		altForward: false,
		altBack: false
	},
	13: {
		step: 13,
		url: '/review-minor',
		access: false,
		displayStep: 10,
		nextStep: 14,
		altNextStep: null,
		prevStep: 9,
		altPrevStep: null,
		altForward: false,
		altBack: false
	},
	14: {
		step: 14,
		url: '/application-review',
		access: false,
		displayStep: null,
		nextStep: 15,
		altNextStep: null,
		prevStep: 13,
		altPrevStep: 9,
		altForward: false,
		altBack: false
	},
	15: {
		step: 15,
		url: '/application-submitted',
		access: false,
		displayStep: null,
		nextStep: null,
		altNextStep: null,
		prevStep: 14,
		altPrevStep: null,
		altForward: false,
		altBack: false
	},
	16: {
		step: 16,
		url: '/application-declined',
		access: true,
		displayStep: null,
		nextStep: 14,
		altNextStep: null,
		prevStep: 0,
		altPrevStep: 9,
		altForward: false,
		altBack: false
	},
}


// WEBPACK FOOTER //
// ./src/utils/stepTracker.js